import script from "./RegistrationApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationApp.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationApp.vue?vue&type=style&index=0&id=a380023a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a380023a"]])

export default __exports__